/*global VeloxGridAndFormController*/


/**
 * This is a basic MVC grid/form controller
 * 
 * It creates 2 routes : #user/list and #user/form
 */
var userController = new VeloxGridAndFormController("velox_user", {
    grid : {
        directory: "views/user",
        name: "userGrid",
        route: "user/list"
    },
    form : {
        directory: "views/user",
        name: "userForm",
        route: "user/form",
        defaultData : {
            auth_type: "password",
            active: true
        }
    }
});

userController.gridController.createSearch = function(){
    return { login : {ope: "<>", value: "anonymous"} } ;
} ;


module.exports = userController ;